var pascalCaseToDotNotation = function pascalCaseToDotNotation(str) {
  if (str.includes('.')) {
    return str;
  }
  var parts = str.split(/(?=[A-Z])/);
  var reversedParts = parts.reverse().map(function (part) {
    return part.toLowerCase();
  });
  var dotNotation = reversedParts.slice(0, 2).join('.');
  var dashNotation = reversedParts.slice(2).reverse().join('-');
  var finalResult = dashNotation ? "".concat(dotNotation, ".").concat(dashNotation) : dotNotation;
  return finalResult;
};
var iconNameMap = {
  'fill.logo.agoda1': 'fill.brand.logo',
  'fill.logo.agoda2': 'fill.brand.logo2',
  'fill.logo.agodacash': 'fill.brand.loyaltycash',
  'fill.logo.agodahome': 'fill.brand.homes',
  'line.logo.agodahome2': 'line.brand.homes2',
  'fill.logo.agodahome2': 'fill.brand.homes2',
  'line.symbol.arrow-down': 'line.symbol.graph-descend',
  'line.symbol.arrow-up': 'line.symbol.graph-ascend',
  'fill.symbol.arrow-down': 'fill.symbol.graph-descend',
  'fill.symbol.arrow-up': 'fill.symbol.graph-ascend',
  'line.electrics.bendingmachine': 'line.electrics.vendingmachine',
  'fill.electrics.bendingmachine': 'fill.electrics.vendingmachine',
  'fill.logo.circle-agodacash': 'fill.brand.circle-loyaltycash',
  'line.symbol.dislike': 'line.symbol.thumbs-down',
  'fill.symbol.dislike': 'fill.symbol.thumbs-down',
  'line.symbol.eidt': 'line.symbol.edit',
  'fill.symbol.eidt': 'fill.symbol.edit',
  'line.symbol.filter1': 'line.symbol.filter',
  'fill.symbol.filter1': 'fill.symbol.filter',
  'fill.transportation.flight-roundtrip': 'fill.transportation.roundtrip',
  'line.transportation.flight-roundtrip': 'line.transportation.roundtrip',
  'fill.logo.pointmax': 'fill.brand.loyaltypoints',
  'line.logo.pointmax': 'line.brand.loyaltypoints',
  'line.symbol.like': 'line.symbol.thumbs-up',
  'fill.symbol.like': 'fill.symbol.thumbs-up',
  'line.symbol.lock': 'line.symbol.lock-locked',
  'fill.symbol.lock': 'fill.symbol.lock-locked',
  'fill.symbol.rotate': 'fill.arrow.rotate',
  'line.symbol.rotate': 'line.arrow.rotate',
  'line.amenity.sweing': 'line.amenity.sewing',
  'fill.amenity.sweing': 'fill.amenity.sewing',
  'fill.amenity.toy': 'fill.activity.kids-club',
  'line.symbol.unlock': 'line.symbol.lock-unlocked',
  'fill.symbol.unlock': 'fill.symbol.lock-unlocked',
  'fill.logo.golocal': 'fill.brand.golocal',
  'fill.symbol.bubble_language': 'fill.symbol.bubble-language',
  'line.symbol.bubble_language': 'line.symbol.bubble-language',
  'fill.logo.unicorn': 'fill.symbol.unicorn',
  'fill.logo.hygine': 'fill.symbol.hygiene',
  'fill.facility.guidedog': 'fill.service.guidedog',
  'line.facility.guidedog': 'line.service.guidedog',
  'fill.symbol.guide': 'fill.service.guide',
  'line.symbol.guide': 'line.service.guide',
  'line.symbol.babysitter': 'line.service.babysitter',
  'fill.symbol.babysitter': 'fill.service.babysitter',
  'fill.symbol.theraphy': 'fill.service.theraphy',
  'line.symbol.theraphy': 'line.service.theraphy',
  'fill.symbol.circle-fork-knife': 'fill.food.circle-fork-knife',
  'fill.logo.ryokan': 'fill.accommodation.circle-ryokan',
  'fill.facility.ryokan': 'fill.accommodation.ryokan',
  'line.facility.ryokan': 'line.accommodation.ryokan',
  'fill.facility.apartment': 'fill.accommodation.apartment',
  'line.facility.apartment': 'line.accommodation.apartment',
  'fill.facility.apartment-hand': 'fill.accommodation.apartment-hand',
  'line.facility.apartment-hand': 'line.accommodation.apartment-hand',
  'fill.facility.bungalow': 'fill.accommodation.bungalow',
  'line.facility.bungalow': 'line.accommodation.bungalow',
  'fill.facility.capsule-female': 'fill.accommodation.capsule-female',
  'line.facility.capsule-female': 'line.accommodation.capsule-female',
  'fill.facility.capsule-male': 'fill.accommodation.capsule-male',
  'line.facility.capsule-male': 'line.accommodation.capsule-male',
  'fill.facility.capsule-hotel': 'fill.accommodation.capsule-hotel',
  'line.facility.capsule-hotel': 'line.accommodation.capsule-hotel',
  'fill.facility.hotel': 'fill.accommodation.hotel',
  'line.facility.hotel': 'line.accommodation.hotel',
  'fill.facility.hotel-flight': 'fill.accommodation.hotel-flight',
  'line.facility.hotel-flight': 'line.accommodation.hotel-flight',
  'fill.facility.villa': 'fill.accommodation.villa',
  'line.facility.villa': 'line.accommodation.villa',
  'fill.facility.house': 'fill.accommodation.house',
  'line.facility.house': 'line.accommodation.house',
  'fill.facility.cart': 'fill.symbol.cart',
  'line.facility.cart': 'line.symbol.cart',
  'fill.facility.cart-empty': 'fill.symbol.cart-empty',
  'fill.facility.church': 'fill.symbol.church',
  'line.facility.church': 'line.symbol.church',
  'fill.facility.city': 'fill.symbol.city',
  'line.facility.city': 'line.symbol.city',
  'fill.facility.city-pin': 'fill.symbol.city-pin',
  'line.facility.city-pin': 'line.symbol.city-pin',
  'fill.facility.door': 'fill.symbol.door',
  'line.facility.door': 'line.symbol.door',
  'fill.facility.door-check': 'fill.symbol.door-check',
  'line.facility.door-check': 'line.symbol.door-check',
  'fill.facility.seat': 'fill.transportation.seat',
  'line.facility.seat': 'line.transportation.seat',
  'fill.facility.seat-pay': 'fill.transportation.seat-pay',
  'line.facility.seat-pay': 'line.transportation.seat-pay',
  'fill.amenity.mask2': 'fill.amenity.facemask',
  'fill.amenity.mask-cross': 'fill.amenity.facemask-cross',
  'line.amenity.mask-cross': 'line.amenity.facemask-cross',
  'fill.symbol.arrow-bothway': 'fill.arrow.bothway',
  'line.symbol.arrow-channel': 'line.arrow.channel',
  'fill.symbol.arrow-channel': 'fill.arrow.channel',
  'line.symbol.arrow-dbl-down': 'line.arrow.dbl-down',
  'fill.symbol.arrow-dbl-down': 'fill.arrow.dbl-down',
  'line.symbol.arrow-dbl-up': 'line.arrow.dbl-up',
  'fill.symbol.arrow-dbl-up': 'fill.arrow.dbl-up',
  'line.symbol.arrow-download': 'line.arrow.download',
  'fill.symbol.arrow-download': 'fill.arrow.download',
  'line.symbol.arrow-exchange': 'line.arrow.exchange',
  'fill.symbol.arrow-exchange': 'fill.arrow.exchange',
  'line.symbol.arrow-leftdown': 'line.arrow.leftdown',
  'fill.symbol.arrow-leftdown': 'fill.arrow.leftdown',
  'line.symbol.arrow-newpage': 'line.arrow.newpage',
  'fill.symbol.arrow-newpage': 'fill.arrow.newpage',
  'fill.symbol.arrow-oneway': 'fill.arrow.oneway',
  'line.symbol.arrow-rightdown': 'line.arrow.rightdown',
  'fill.symbol.arrow-rightdown': 'fill.arrow.rightdown',
  'line.symbol.arrow-share': 'line.arrow.share',
  'fill.symbol.arrow-share': 'fill.arrow.share',
  'line.symbol.arrow-sort': 'line.arrow.sort',
  'fill.symbol.arrow-sort': 'fill.arrow.sort',
  'line.symbol.arrow-thick-back': 'line.arrow.thick-back',
  'fill.symbol.arrow-thick-back': 'fill.arrow.thick-back',
  'line.symbol.arrow-thick-collapse': 'line.arrow.thick-collapse',
  'fill.symbol.arrow-thick-collapse': 'fill.arrow.thick-collapse',
  'line.symbol.arrow-thick-down': 'line.arrow.thick-down',
  'fill.symbol.arrow-thick-down': 'fill.arrow.thick-down',
  'line.symbol.arrow-thick-dropdown': 'line.arrow.thick-dropdown',
  'fill.symbol.arrow-thick-dropdown': 'fill.arrow.thick-dropdown',
  'line.symbol.arrow-thick-forward': 'line.arrow.thick-forward',
  'fill.symbol.arrow-thick-forward': 'fill.arrow.thick-forward',
  'line.symbol.arrow-thick-left': 'line.arrow.thick-left',
  'fill.symbol.arrow-thick-left': 'fill.arrow.thick-left',
  'line.symbol.arrow-thick-leftright': 'line.arrow.thick-leftright',
  'fill.symbol.arrow-thick-leftright': 'fill.arrow.thick-leftright',
  'line.symbol.arrow-thick-right': 'line.arrow.thick-right',
  'fill.symbol.arrow-thick-right': 'fill.arrow.thick-right',
  'line.symbol.arrow-thick-up': 'line.arrow.thick-up',
  'fill.symbol.arrow-thick-up': 'fill.arrow.thick-up',
  'line.symbol.arrow-thick-updown': 'line.arrow.thick-updown',
  'fill.symbol.arrow-thick-updown': 'fill.arrow.thick-updown',
  'line.symbol.arrow-thin-back': 'line.arrow.thin-back',
  'fill.symbol.arrow-thin-back': 'fill.arrow.thin-back',
  'line.symbol.arrow-thin-collapse': 'line.arrow.thin-collapse',
  'fill.symbol.arrow-thin-collapse': 'fill.arrow.thin-collapse',
  'line.symbol.arrow-thin-down': 'line.arrow.thin-down',
  'fill.symbol.arrow-thin-down': 'fill.arrow.thin-down',
  'line.symbol.arrow-thin-dropdown': 'line.arrow.thin-dropdown',
  'fill.symbol.arrow-thin-dropdown': 'fill.arrow.thin-dropdown',
  'line.symbol.arrow-thin-forward': 'line.arrow.thin-forward',
  'fill.symbol.arrow-thin-forward': 'fill.arrow.thin-forward',
  'line.symbol.arrow-thin-left': 'line.arrow.thin-left',
  'fill.symbol.arrow-thin-left': 'fill.arrow.thin-left',
  'line.symbol.arrow-thin-leftright': 'line.arrow.thin-leftright',
  'fill.symbol.arrow-thin-leftright': 'fill.arrow.thin-leftright',
  'line.symbol.arrow-thin-right': 'line.arrow.thin-right',
  'fill.symbol.arrow-thin-right': 'fill.arrow.thin-right',
  'line.symbol.arrow-thin-up': 'line.arrow.thin-up',
  'fill.symbol.arrow-thin-up': 'fill.arrow.thin-up',
  'line.symbol.arrow-thin-updown': 'line.arrow.thin-updown',
  'fill.symbol.arrow-thin-updown': 'fill.arrow.thin-updown',
  'line.symbol.arrow-todown': 'line.arrow.todown',
  'fill.symbol.arrow-todown': 'fill.arrow.todown',
  'line.symbol.arrow-totop': 'line.arrow.totop',
  'fill.symbol.arrow-totop': 'fill.arrow.totop',
  'line.symbol.arrow-turn': 'line.arrow.turn',
  'fill.symbol.arrow-turn': 'fill.arrow.turn',
  'line.symbol.arrow-upleft': 'line.arrow.upleft',
  'fill.symbol.arrow-upleft': 'fill.arrow.upleft',
  'line.symbol.arrow-upload': 'line.arrow.upload',
  'fill.symbol.arrow-upload': 'fill.arrow.upload',
  'line.symbol.arrow-upright': 'line.arrow.upright',
  'fill.symbol.arrow-upright': 'fill.arrow.upright',
  'line.symbol.circle-arrow-down': 'line.arrow.circle-down',
  'fill.symbol.circle-arrow-down': 'fill.arrow.circle-down',
  'line.symbol.circle-arrow-left': 'line.arrow.circle-left',
  'fill.symbol.circle-arrow-left': 'fill.arrow.circle-left',
  'line.symbol.circle-arrow-right': 'line.arrow.circle-right',
  'fill.symbol.circle-arrow-right': 'fill.arrow.circle-right',
  'line.symbol.circle-arrow-up': 'line.arrow.circle-up',
  'fill.symbol.circle-arrow-up': 'fill.arrow.circle-up',
  'line.symbol.loop': 'line.arrow.loop',
  'fill.symbol.loop': 'fill.arrow.loop',
  'line.symbol.size': 'line.arrow.size',
  'fill.symbol.size': 'fill.arrow.size',
  'line.symbol.zoom-in': 'line.arrow.zoom-in',
  'fill.symbol.zoom-in': 'fill.arrow.zoom-in',
  'line.symbol.zoom-out': 'line.arrow.zoom-out',
  'fill.symbol.zoom-out': 'fill.arrow.zoom-out',
  'fill.symbol.adult1': 'fill.people.adult1',
  'fill.symbol.adult2': 'fill.people.adult2',
  'line.symbol.baby': 'line.people.baby',
  'fill.symbol.baby': 'fill.people.baby',
  'line.symbol.baby-no': 'line.people.baby-no',
  'fill.symbol.baby-no': 'fill.people.baby-no',
  'fill.symbol.child': 'fill.people.child',
  'fill.symbol.circle-user': 'fill.people.circle-user',
  'line.symbol.circle-user': 'line.people.circle-user',
  'fill.symbol.emoji-angry': 'fill.people.emoji-angry',
  'line.symbol.emoji-angry': 'line.people.emoji-angry',
  'fill.symbol.emoji-dislike': 'fill.people.emoji-dislike',
  'line.symbol.emoji-dislike': 'line.people.emoji-dislike',
  'fill.symbol.emoji-heart': 'fill.people.emoji-heart',
  'line.symbol.emoji-heart': 'line.people.emoji-heart',
  'fill.symbol.emoji-like': 'fill.people.emoji-like',
  'line.symbol.emoji-like': 'line.people.emoji-like',
  'fill.symbol.emoji-meh': 'fill.people.emoji-meh',
  'line.symbol.emoji-meh': 'line.people.emoji-meh',
  'fill.symbol.emoji-normal': 'fill.people.emoji-normal',
  'line.symbol.emoji-normal': 'line.people.emoji-normal',
  'fill.symbol.family': 'fill.people.family',
  'line.symbol.family': 'line.people.family',
  'fill.symbol.family2': 'fill.people.family2',
  'fill.symbol.gender': 'fill.people.gender',
  'line.symbol.gender': 'line.people.gender',
  'fill.symbol.infant': 'fill.people.infant',
  'fill.symbol.kid': 'fill.people.kid',
  'line.symbol.lid': 'line.people.kid',
  'fill.symbol.people': 'fill.people.people',
  'line.symbol.people': 'line.people.people',
  'fill.symbol.sit': 'fill.people.sit',
  'line.symbol.sit': 'line.people.sit',
  'fill.symbol.traveler': 'fill.people.traveler',
  'line.symbol.traveler': 'line.people.traveler',
  'fill.symbol.user': 'fill.people.user',
  'line.symbol.user': 'line.people.user',
  'fill.symbol.user-add': 'fill.people.user-add',
  'line.symbol.user-add': 'line.people.user-add',
  'fill.symbol.user-address': 'fill.people.user-address',
  'line.symbol.user-address': 'line.people.user-address',
  'fill.symbol.user-detail': 'fill.people.user-detail',
  'line.symbol.user-detail': 'line.people.user-detail',
  'fill.symbol.user-setting': 'fill.people.user-setting',
  'line.symbol.user-setting': 'line.people.user-setting',
  'fill.symbol.user-star': 'fill.people.user-star',
  'line.symbol.user-star': 'line.people.user-star',
  'fill.symbol.users': 'fill.people.users',
  'line.symbol.users': 'line.people.users',
  'fill.symbol.group-star': 'fill.people.group-star',
  'fill.symbol.rotate-360': 'fill.arrow.rotate-360',
  'fill.logo.specialoffers': 'fill.brand.specialoffers',
  'line.logo.specialoffers': 'line.brand.specialoffers',
  'fill.logo.vipstar': 'fill.brand.vipstar',
  'fill.symbol.group-people': 'fill.people.group-people',
  'fill.facility.shoppingcart': 'fill.symbol.cart'
};
var mapLegacyIconId = function mapLegacyIconId(iconName) {
  var dotNotationName = pascalCaseToDotNotation(iconName);
  return iconNameMap[dotNotationName] || dotNotationName;
};

export { mapLegacyIconId };
//# sourceMappingURL=iconMapper.js.map
